export default {
  install: Vue => {
    const files = import.meta.glob('./*.vue', { eager: true })
    Object.values(files).forEach(({ default: component }) => {
      Vue.component(component.__name, component)
    })
  }
}
